import { render, staticRenderFns } from "./help-better.vue?vue&type=template&id=00f9e9be&scoped=true"
import script from "./help-better.vue?vue&type=script&lang=js"
export * from "./help-better.vue?vue&type=script&lang=js"
import style0 from "./help-better.vue?vue&type=style&index=0&id=00f9e9be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f9e9be",
  null
  
)

export default component.exports